const ParticipantColors = ['fill-accent-blue-default',
// #00A4BD
'fill-accent-green-default',
// #00BDA5
'fill-accent-magenta-default',
// #F2547D
'fill-accent-neutral-default',
// #425B76
'fill-accent-orange-default',
// #FF7A59
'fill-accent-purple-default',
// #AC98F8
'fill-accent-red-default',
// #F2545B
'fill-accent-yellow-default' // #F5C26B
];
export const getParticipantColor = participantIndex => {
  return ParticipantColors[participantIndex % ParticipantColors.length] || undefined;
};